import React from "react";
import { Button, useMutation, useNotify, useRedirect } from "react-admin";
import { useFormState } from "react-final-form";
import SaveIcon from "@material-ui/icons/Save";

interface ISaveButtonSubcontractorAdjustmentPrice {
  formInvalid: boolean;
}

const SaveButtonSubcontractorAdjustmentPrice = ({
  formInvalid,
}: ISaveButtonSubcontractorAdjustmentPrice) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { values } = useFormState();

  const [saveAdjustmentPrice, { loading: saveLoading }] = useMutation(
    {
      type: "create",
      resource: "subcontractorAdjustmentPrices",
      payload: {
        data: {
          subcontractorAdjustmentPrices: [
            {
              schoolId: values.schoolId,
              subcontractorId: values.subcontractorId,
              busScheduleId: values.busScheduleId,
              routeId: values.routeId,
              price: Number(Math.round(Number(values.amount) * 100.0)),
            },
          ],
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        notify("Success Update Subcontractor Adjustment Price", "info");
        redirect(`/subcontractors/${values.subcontractorId}/show/2`);
      },
      onFailure: (error) => {
        notify(
          `Failed Update Subcontractor Adjustment Price, error: ${error.message}`,
          "error",
        );
      },
    },
  );

  const [updateAdjustmentPrice, { loading: updateLoading }] = useMutation(
    {
      type: "update",
      resource: "subcontractorAdjustmentPrices",
      payload: {
        id: values.id,
        data: {
          price: Number(Math.round(Number(values.amount) * 100.0)),
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        notify("Success Update Subcontractor Adjustment Price", "info");
        redirect(`/subcontractors/${values.subcontractorId}/show/2`);
      },
      onFailure: (error) => {
        notify(
          `Failed Update Subcontractor Adjustment Price, error: ${error.message}`,
          "error",
        );
      },
    },
  );

  return values.status === "approved" ? (
    <Button
      label={saveLoading ? `Loading...` : `Save`}
      disabled={formInvalid || saveLoading}
      onClick={saveAdjustmentPrice}
    >
      <SaveIcon />
    </Button>
  ) : (
    <Button
      label={updateLoading ? `Loading...` : `Save`}
      disabled={formInvalid || updateLoading}
      onClick={updateAdjustmentPrice}
    >
      <SaveIcon />
    </Button>
  );
};

export default SaveButtonSubcontractorAdjustmentPrice;
